import React from "react";

export default function VibeTag({ children, tone = "default", className = "" }) {
  const tones = {
    default:
      "border-white/10 text-white/75 bg-white/[0.03]",
    gold:
      "border-[rgba(212,175,55,0.4)] text-[#F2DE94] bg-[rgba(212,175,55,0.08)]",
    forest:
      "border-[rgba(74,163,106,0.4)] text-[#8FD6A6] bg-[rgba(74,163,106,0.08)]",
    burgundy:
      "border-[rgba(185,58,80,0.4)] text-[#F5A8B5] bg-[rgba(185,58,80,0.08)]",
    ghost: "border-white/5 text-white/55 bg-transparent",
  };
  return (
    <span
      data-testid="vibe-tag"
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium tracking-wide ${tones[tone]} ${className}`}
    >
      {children}
    </span>
  );
}
